export default __webpack_public_path__ + "static/oleh-ravlyk-6adb9cbafc3bef1288e6958a11fa6fe7.jpeg";